import { useEffect } from 'react';

type ReportParams = {
  timer?: number,
};

export function stayOnReport(params: ReportParams = {}) {
  const timer = params.timer || 5 * 1000; // 默认为每5s做一次合计，判断是否上报

  // 每轮计时开始时间
  let roundStartTime = +new Date();

  // 当前页面是否失焦
  let onblur = false;
  // 监听页面失焦事件
  window.onblur = function () {
    if (window._stayOnReportInterval) {
      clearInterval(window._stayOnReportInterval);
      // 清空计数器，并重置统计状态
      window._stayOnReportInterval = null;
    }

    // 当前这轮监听的时长
    const roundTimeInterval = Number(+new Date()) - Number(roundStartTime);
    if (roundTimeInterval >= timer / 2) {
      // 如果此轮监听时长超过一轮的一半，即2.5s，则进行一次上报
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      report(true);
    }

    // 记录为失焦状态
    onblur = true;
  };

  function report(forceReport = false) {
    // 非失焦状态 或 强制执行 时，进行上报
    if (!onblur || forceReport) {
      const href = window.location.href;

      // 上报活跃埋点
      window.log && window.log('yx_center', 'Pvkeep', href);
    }

    // 重置时间
    roundStartTime = +new Date();
  }

  /**
   * 监听页面聚焦事件
   */
  window.onfocus = function () {
    if (!window._stayOnReportInterval) {
      window._stayOnReportInterval = setInterval(function () {
        report();
      }, timer);
    }
    onblur = false;
  };

  /**
   * 当不存在计时器时，进行生成
   */
  if (!window._stayOnReportInterval) {
    /**
     * 初始化时计时器开始
     * @type {NodeJS.Timeout}
     * @private
     */
    window._stayOnReportInterval = setInterval(function () {
      report();
    }, timer);
  }

  return { interval: window._stayOnReportInterval };
}

// 使用：在需要监听的页面里添加

/* class组件 */
// componentDidMount() {
//   // 开始监听用户页面停留时长
//   this.stayOnReportInterval = stayOnReport()
// }
//
// componentWillUnmount() {
//
//   // 清除定时装置
//   clearInterval(this.stayOnReportInterval.interval)
// }
/** HOOKS */
// useEffect(() => {
//   const report = stayOnReport({ timer: 5000 })
//   return () => {
//     clearInterval(report.interval)
//   }
// }, [])

export default function useStayReport() {
  useEffect(() => {
    const report = stayOnReport({ timer: 5000 });
    return () => {
      clearInterval(report.interval);
    };
  }, []);
}
